import React, { useEffect } from 'react';
import { DatePicker } from 'antd';
import { praxPickerProps, praxRangeToApi, praxDefaultRange } from './praxPicker';
import './CustomRangePicker.css';  // Importando o CSS

const { RangePicker } = DatePicker;

const CustomRangePicker = ({ setDataInicio, setDataFim, resetSearch, id }) => {
  // Período padrão: mês atual
  useEffect(() => {
    const [inicio, fim] = praxRangeToApi(praxDefaultRange());
    setDataInicio(inicio);
    setDataFim(fim);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="d-flex col-7 col-md-auto px-rangepicker">
      <RangePicker
        {...praxPickerProps()}
        style={{
          width: '100%', // Faz o RangePicker ocupar 100% da largura
        }}
        onChange={(dates) => {
          const [inicio, fim] = praxRangeToApi(dates);
          setDataInicio(inicio);
          setDataFim(fim);
          if (!inicio && resetSearch) {
            resetSearch(id);
          }
        }}
      />
    </div>
  );
};

export default CustomRangePicker;
